module.exports = __webpack_public_path__ + "static/media/talk-light-logo.a309d4b6.png";